import { useEffect, useState } from 'react';
import type { Placement, PlacementsResponse, User } from '../lib/types';
import { getAccessToken } from '../lib/auth';

export type PlacementsState =
  | { status: 'loading' }
  | { status: 'ok'; placements: Placement[]; user: User }
  | { status: 'error'; message: string };

export function usePlacements(enabled: boolean): PlacementsState {
  const [state, setState] = useState<PlacementsState>({ status: 'loading' });

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    (async () => {
      setState({ status: 'loading' });
      try {
        const token = await getAccessToken();
        if (!token) throw new Error('Could not acquire a sign-in token — please reload.');
        const res = await fetch('/api/placements', {
          headers: { 'X-User-Token': token },
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const body = (await res.json()) as PlacementsResponse;
        if (!cancelled) {
          setState({ status: 'ok', placements: body.placements, user: body.user });
        }
      } catch (err) {
        if (!cancelled) {
          setState({ status: 'error', message: err instanceof Error ? err.message : String(err) });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [enabled]);

  return state;
}